@import "../../node_modules/breakpoint-sass/stylesheets/breakpoint";

//responsive sizes
$xs: 320px;
$sm: 374px;
$md: 640px;
$lg: 1024px;
$xl: 1200px;
$xxl: 1440px;
$xxxl: 1600px;



//responsive ranges
$xsmall-range: $xs 373px; /* 0, 640px */
$small-range: $sm 639px;
$medium-range: $md 1023px; /* 641px, 1024px */
$large-range: $lg 1199px; /* 1025px, 1440px */
$xlarge-range: $xl 1439px; /* 1441px, 1920px */
$xxlarge-range: $xxl 1599px; /* 1441px, 1920px */


@mixin container() {
  max-width: 1024px;
  width: 100%;
  margin: auto;
}

@mixin container_inner_narrow() {
  width: 720px;
  margin: auto;
}

@mixin xs() {
  @include breakpoint($xsmall-range) {
    @content;
  }
}

@mixin sm($qualify: false) {
  @if $qualify == up {
    @include breakpoint($sm) {
      @content;
    }
  }
  @if $qualify == down {
    @include breakpoint(0 373px) {
      @content;
    }
  } @else {
    @include breakpoint($small-range) {
      @content;
    }
  }
}


@mixin md($qualify: false) {
  @if $qualify == up {
    @include breakpoint($md) {
      @content;
    }
  }
  @if $qualify == down {
    @include breakpoint(0 639px) {
      @content;
    }
  } @else {
    @include breakpoint($medium-range) {
      @content;
    }
  }
}

@mixin lg($qualify: false) {
  @if $qualify == up {
    @include breakpoint($lg) {
      @content;
    }
  }
  @if $qualify == down {
    @include breakpoint(0 1023px) {
      @content;
    }
  } @else {
    @include breakpoint($large-range) {
      @content;
    }
  }
}

@mixin xl($qualify: false) {
  @if $qualify == up {
    @include breakpoint($xl) {
      @content;
    }
  }
  @if $qualify == down {
    @include breakpoint(0 1439px) {
      @content;
    }
  } @else {
    @include breakpoint($xlarge-range) {
      @content;
    }
  }
}

@mixin xxl($qualify: false) {
  @if $qualify == up {
    @include breakpoint($xxl) {
      @content;
    }
  }
  @if $qualify == down {
    @include breakpoint(0 1599px) {
      @content;
    }
  } @else {
    @include breakpoint($xxlarge-range) {
      @content;
    }
  }
}

@mixin xxxl() {
    @include breakpoint($xxxl) {
      @content;
    }
  }

@mixin xlg() {
  @include breakpoint($xlarge-range) {
    @content;
  }
}